import React from "react";

import SortingOrder from "components/common/sortingOrder/SortingOrder";
import SearchField from "components/common/customSearchField/CustomSearchField";
import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import ClearFiltersIcon from "assets/icons/ClearFiltersIcon";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getIcon } from "common/constants/constants";
import { useTranslation } from "react-i18next";
const BranchUserFilter = (props) => {
  const {
    handleChange,
    rolesList,
    productList,
    searchPlaceholder,
    filters,
    orderByList,
    resetFilters,
  } = props;
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        <Col
          md={1}
          xs={2}
          className="d-flex flex-md-column align-items-center  justify-content-md-center justify-content-around align-item-center flex-row">
          {filters.orderBy ? (
            <SortingOrder handleChange={handleChange} value={filters.orderType} />
          ) : (
            <div
              style={{
                pointerEvents: "none",
                opacity: 0.4,
              }}>
              <SortingOrder handleChange={handleChange} value={filters.orderType} />
            </div>
          )}

          {Object.values(filters).some((el) => el !== "DESC" && el.length > 0) ? (
            <ClearFiltersIcon resetFilters={resetFilters} />
          ) : (
            <div style={{ marginRight: "37px" }}></div>
          )}
        </Col>
        <Col>
          <SearchField
            name="searchString"
            placeholder={searchPlaceholder}
            value={filters.searchString}
            margin="6px 13px"
            {...props}
          />
        </Col>
        <Col>
          <SearchableSelect
            name="orderBy"
            placeholder={t("sort-by")}
            options={orderByList?.map((el) => {
              return { value: el.value, label: el.name };
            })}
            value={filters.orderBy}
            handleChange={handleChange}
            className=" eg-bar-select "
          />
        </Col>
        <Col>
          <SearchableSelect
            placeholder={t("all-products")}
            name="products"
            options={productList.map((el) => {
              return {
                value: "%23" + el.productKey.substring(1),
                label: el.translatedValue,
                icon: getIcon[el?.productKey.replaceAll("#", "").toLowerCase()],
              };
            })}
            handleChange={(key, value) => handleChange(key, value)}
            value={filters?.products}
            isMulti={true}
            className=" eg-bar-select "
            withIcon
          />
        </Col>
        <Col>
          <SearchableSelect
            placeholder={t("all-roles")}
            name="roles"
            options={rolesList?.map((role) => {
              return { value: role.name, label: t(role.name) };
            })}
            handleChange={(key, value) => handleChange(key, value)}
            value={filters?.roles}
            isMulti={true}
            className=" eg-bar-select "
          />
        </Col>
      </Row>
    </Container>
  );
};

export default BranchUserFilter;
